<template>
  <div
    class="video-control-arrows"
    :style="style"
    @mousedown.stop="moveCamera"
    @pointerdown.stop
  >
    <v-icon :size="iconSize">fas fa-arrows-alt</v-icon>
    <svg :style="style" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle fill="#fff" cx="50" cy="50" r="50" class="video-control-circle" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "VideoMovementControls",
  props: {
    size: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    style() {
      const heigthCSS = `height: ${this.size}px;`;
      const widthCSS = `width: ${this.size}px;`;
      return `${heigthCSS}${widthCSS}`;
    },
    iconSize() {
      return `${Math.round(this.size * 0.8) + 1}px`;
    },
  },
  methods: {
    moveCamera(event) {
      const x = event.offsetX - this.size / 2;
      const y = -(event.offsetY - this.size / 2);
      const angle = (Math.atan2(y, x) * 180) / Math.PI;
      if (angle < 45 && angle > -45) {
        // RIGHT
        this.$emit("arrowPress", "right");
      } else if (angle < 135 && angle > 45) {
        // UP
        this.$emit("arrowPress", "up");
      } else if (angle < -135 || angle > 135) {
        // LEFT
        this.$emit("arrowPress", "left");
      } else if (angle < -45 && angle > -135) {
        // DOWN
        this.$emit("arrowPress", "down");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-control-arrows {
  -webkit-filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.7));
  filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.7));
  pointer-events: none;
  opacity: 0.6;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    pointer-events: none;
    position: absolute;
  }
  svg {
    circle {
      pointer-events: auto;
      cursor: pointer;
      fill: #fff;
    }
  }
  &:hover {
    opacity: 1;
  }
}
.video-control-circle:active {
  fill: #207cad !important;
}
</style>
